import { useSnackbar } from "notistack";

export default useSnackbar;